module.exports = __webpack_public_path__ + "img/btn_link_5.ed09a3dc.png";